import { format } from "date-fns";
import { ROUTES, callAPI } from "../API/index";
import { fetchCodeList, renameKeys } from "./ServiceCommon";

// -----------------------------------------------
// HRM
// -----------------------------------------------
export const fetchEmployeeList = (filterData) => {
    /**
     * 사원 목록 반환
     */
    return callAPI(ROUTES.HRM.EMPLOYEES, 'GET', {}, filterData);
}

export const fetchEmployeeMenuItems = async (filterData) => {
    /**
     * 사원 목록 MenuItems 형태로 반환
     */
    try {
        const data = await callAPI(ROUTES.HRM.EMPLOYEES, 'GET', {}, filterData); // API 호출

        // 데이터가 배열이 아닌 경우 처리
        let employeeList = data;
        if (!Array.isArray(data)) {
            // 데이터가 객체인 경우 배열 속성을 찾거나 빈 배열 반환
            if (data && typeof data === 'object') {
                // 일반적인 API 응답 구조 확인
                employeeList = data.employees || data.data || data.list || data.results || [];
            } else {
                employeeList = [];
            }
        }

        // 배열이 아니거나 빈 배열인 경우 빈 배열 반환
        if (!Array.isArray(employeeList) || employeeList.length === 0) {
            console.log('fetchEmployeeMenuItems - 유효한 사원 데이터가 없습니다.');
            return [];
        }

        const menuItemKeyMap = { no: ['key', 'value'] };
        let menuItems = employeeList.map(item => renameKeys(item, menuItemKeyMap))

        menuItems.map((item) => {
            item.text = item.departmentName + " - " + item.positionName + " - " + item.name;
            return item;
        })

        return menuItems
    } catch (error) {
        console.error("사원 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const createEmployee = (formData, empl_no) => {
    /**
     * 사원 생성
     */

    const transformedData = {
        ...formData,
        mdwkWorkday: formData.mdwkWorkday.join(','),
        encpnd: formData.encpnd ? format(formData.encpnd, 'yyyy-MM-dd') : undefined,
        retireDate: formData.retireDate ? format(formData.retireDate, 'yyyy-MM-dd') : undefined,
        dcexpDate: formData.dcexpDate ? format(formData.dcexpDate, 'yyyy-MM-dd') : undefined,

        baseAtendtime: formData.baseAtendtime ? format(formData.baseAtendtime, 'HH:mm') : undefined,
        baseLvofctime: formData.baseLvofctime ? format(formData.baseLvofctime, 'HH:mm') : undefined,
    }
    // console.log(transformedData)

    return callAPI(ROUTES.HRM.EMPLOYEES, 'POST', transformedData, { empl_no });
}

export const updateEmployee = (formData, empl_no) => {
    /**
     * 사원 생성
     */

    const transformedData = {
        ...formData,
        mdwkWorkday: formData.mdwkWorkday.join(','),
        encpnd: formData.encpnd ? format(formData.encpnd, 'yyyy-MM-dd') : undefined,
        retireDate: formData.retireDate ? format(formData.retireDate, 'yyyy-MM-dd') : undefined,
        dcexpDate: formData.dcexpDate ? format(formData.dcexpDate, 'yyyy-MM-dd') : undefined,

        baseAtendtime: formData.baseAtendtime ? format(formData.baseAtendtime, 'HH:mm') : undefined,
        baseLvofctime: formData.baseLvofctime ? format(formData.baseLvofctime, 'HH:mm') : undefined,
    }
    // console.log(transformedData)

    return callAPI(ROUTES.HRM.EMPLOYEE, 'POST', transformedData, { empl_no });
}


export const fetchEmployeeAddCodeListMenuItems = async () => {
    /**
     * 사원 생성 코드 목록 반환
     */
    try {
        const data = await fetchCodeList(["0014", "0015", "0021", "0022", "0023", "0025"]); // API 호출
        const menuItemKeyMap = { subcategory: ['key', 'value'], value: 'text' }

        const resp = data.code_list
        const resp_message = data.message
        const menuItems0014 = resp.filter((item) => item.category === "0014" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0015 = resp.filter((item) => item.category === "0015" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0021 = resp.filter((item) => item.category === "0021" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0022 = resp.filter((item) => item.category === "0022" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0023 = resp.filter((item) => item.category === "0023" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0025 = resp.filter((item) => item.category === "0025" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))

        return {
            salaryFormItems: menuItems0014,
            employmentFormItems: menuItems0015,
            relationshipItems: menuItems0021,
            bankItems: menuItems0022,
            insuranceItems: menuItems0023,
            employeeTypeItems: menuItems0025,
            resp_message: resp_message
        }
    } catch (error) {
        console.error("사원 추가 코드 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchCompanyAddCodeListMenuItems = async () => {
    /**
     * 회사 생성 코드 목록 반환
     */
    try {
        const data = await fetchCodeList(["0022", "0024"]); // API 호출
        const menuItemKeyMap = { subcategory: ['key', 'value'], value: 'text' }

        const resp = data.code_list
        const resp_message = data.message
        const menuItems0022 = resp.filter((item) => item.category === "0022" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0024 = resp.filter((item) => item.category === "0024" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        return {
            bankItems: menuItems0022,
            retirementPensionItems: menuItems0024,
            resp_message: resp_message
        }
    } catch (error) {
        console.error("사원 추가 코드 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchEmployee = (empl_no) => {
    /**
     * 사원 조회
     */
    return callAPI(ROUTES.HRM.EMPLOYEE, 'GET', {}, { empl_no });
}

export const deleteEmployee = (empl_no) => {
    /**
     * 사원 삭제
     */
    return callAPI(ROUTES.HRM.EMPLOYEE, 'DELETE', {}, { empl_no });
}
